import { MemoryRouter } from "react-router-dom";
import { AppRouter } from "./router/AppRouter";
import { AddinHeader } from "./components/organisms/AddinHeader";
import { ResolveContractOnOpenGate } from "./components/organisms/ResolveContractOnOpenGate";

/**
 * Office task panes load as /taskpane.html (or similar). MemoryRouter must start on an
 * in-app path or navigation after mount can appear to do nothing. Hash URLs like #/login
 * are honored when they match app routes.
 */
function getInitialMemoryPath(): string {
  const { pathname, search, hash } = window.location;
  if (hash.startsWith("#/")) {
    const inner = hash.slice(1);
    const base = inner.split("?")[0] ?? "/";
    if (
      base.startsWith("/login") ||
      base.startsWith("/okta") ||
      base.startsWith("/contractiq") ||
      base.startsWith("/prizelogic")
    ) {
      return inner;
    }
  }
  if (
    pathname.startsWith("/login") ||
    pathname.startsWith("/okta") ||
    pathname.startsWith("/contractiq") ||
    pathname.startsWith("/prizelogic")
  ) {
    return `${pathname}${search}${hash}`;
  }
  return "/";
}

export const App = () => (
  <div
    className="flex h-screen w-full flex-col bg-background"
    style={{ minWidth: 320 }}
  >
    <MemoryRouter initialEntries={[getInitialMemoryPath()]} initialIndex={0}>
      <AddinHeader />
      <main className="flex-1 overflow-auto p-4">
        <ResolveContractOnOpenGate />
        <AppRouter />
      </main>
    </MemoryRouter>
  </div>
);
